<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading" epub:type="dedication" id="dedication" role="doc-dedication">
<div class="text" id="dedication-text">
<p class="first first-in-chapter first-full-width dedication-content">For Drew</p>
<p class="subsq dedication-content">Grief is just love with nowhere to go…</p>
<div class="inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-tall block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin inline-image-before-element-end">
<div class="inline-image-container">
<img alt="" src="images/matrg-dedication.jpg"/>
</div>
</div>
<blockquote class="written-note block-height-not-mult-of-line-height">
<div class="written-note-group written-note-alignment-center-group">
<p class="written-note-content written-note-alignment-center-content dedication-content">Drew Peter George Cockton</p>
<p class="written-note-content written-note-alignment-center-content dedication-content">1986-2022</p>
</div>
</blockquote>
<div class="inline-image inline-image-kind-photograph inline-image-size-small inline-image-flow-center inline-image-flow-within-text inline-image-aspect-wide block-height-not-mult-of-line-height inline-image-without-caption inline-image-after-section-begin">
<div class="inline-image-container">
<img alt="" src="images/matrg---dedication.jpg"/>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?b2bd2220